// extracted by mini-css-extract-plugin
var _1 = "MenuLogo-moduleMenuLogo__TINry CompanyLink-moduleCompanyLink__jbr98";
var _2 = "MenuLogo-modulecompanyLogo__tOHDq CompanyLogo-moduleCompanyLogo__JTc6u";
var _3 = "MenuLogo-modulelogo__MBXoh MenuDefaultLogo-moduleMenuDefaultLogo__ceM0r";
export { _1 as "MenuLogo", _2 as "companyLogo", _3 as "logo" }
